import Login from '../Pages/Login.vue'
import Register from '../Pages/Register.vue'
import SecurityPage from "../Views/SecurityPage.vue";
import VerifyEmail from '../Pages/VerifyEmail.vue'
import ForgotPassword from '../Pages/ForgotPassword.vue'
import VerifyEmailPassword from '../Pages/VerifyEmailPassword.vue'
import EmailVerified from '../Pages/EmailVerified.vue'
import ResetPassword from '../Pages/ResetPassword.vue'
import ChangePassword from '../Pages/ChangePassword'


const routes = [
  {
    path: '/',
    component: SecurityPage,
    children: [
      {
        path: '/',
        name: 'Login',
        component: Login,
      },
      {
        path: '/register',
        name: 'Register',
        component: Register,
      },
      {
        path: '/sso/:id_token',
        name: 'SSOLogin',
        component: Login,
      },
      {
        path: '/verify_Email',
        name: 'VerifyEmail',
        component: VerifyEmail,
      },
      {
        path: '/forgot_password',
        name: 'ForgotPassword',
        component: ForgotPassword,
      },
      {
        path: '/verify_email_password',
        name: 'VerifyEmailPassword',
        component: VerifyEmailPassword,
      },
      {
        path: '/email_verified',
        name: 'EmailVerified',
        component: EmailVerified,
      },
      {
        path: '/reset_password',
        name: 'ResetPassword',
        component: ResetPassword,
      },
      {
        path: '/change_password',
        name: 'ChangePassword',
        component: ChangePassword,
        meta: {
          authRequired: true
        }
      }
    ]
  }
]

export default routes
